import React, { Component } from 'react';
import { connect } from 'react-redux';
import { reduxForm } from 'redux-form';

export class FormCadastroPercursoMdfe extends Component {

    exibirPercursosSelecionados() {
        return (
            <table className="table table-sm table-bordered">
                <thead>
                    <tr className='text-center'>
                        <th colSpan='3'>Percursos MDF-e</th>
                    </tr>
                    <tr>
                        <th>UF</th>
                        <th>Ordem</th>
                        <th />
                    </tr>
                </thead>
                <tbody>
                    {!this.props.percursoMdfe || this.props.percursoMdfe.length === 0 ?
                        <tr className="alert alert-warning text-center mt-4" role="alert">
                            <td colSpan='3'>Nenhum percurso selecionado.</td>
                        </tr>
                        : this.props.percursoMdfe.map((it, index) => (
                            <tr key={`percurso-mdfe-${index}`}>
                                <td>{it.uf}</td>
                                <td>{it.ordem}</td>
                                <td className='text-center' style={{ cursor: 'pointer', color: 'red' }}>
                                    {this.props.exibirBotaoSalvar() && (
                                        <div onClick={(e) => { e.preventDefault(); this.props.removerPercursoMdfe(it.hash) }}>
                                            Remover
                                        </div>
                                    )}
                                </td>
                            </tr>
                        ))
                    }
                </tbody>
            </table>
        )
    }

    exibirBotaoAdicionar() {
        return (
            <div className="vx-gp-toolbar mb-3">
                <button data-toggle="modal"
                    data-target="#modalCadastrarPercursoMdfe"
                    className="vx-btn-primary" onClick={(e) => e.preventDefault()}>
                    <i className="material-icons">add</i>
                    Adicionar Percurso
                </button>
            </div>
        )
    }

    render() {
        return (
            <div>
                <div className="col-12 col-sm-12 col-md-10 mt-2">
                    {this.props.exibirBotaoSalvar() && this.exibirBotaoAdicionar()}
                    {this.exibirPercursosSelecionados()}
                </div>
            </div>
        )
    }
}

export function mapStateToProps(state) {
    return {
        empresaSelecionada: state.empresaSelecionada,
    }
}

export default connect(mapStateToProps, {})(reduxForm({
    form: 'formularioCadastroMdfe'
})(FormCadastroPercursoMdfe));
